import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHistory } from 'react-router-dom';
import { editSale } from 'services/api/requests/commercial';
import { mapErrorToToastProps } from 'utils/forms/mapErrorToToastProps';

export const useEditSale = (
	id: number,
	onErrorHierarchyNotFound?: VoidFunction
) => {
	const queryClient = useQueryClient();
	const history = useHistory();
	const toast = useToast();

	return useMutation((body: any) => editSale(body, id), {
		onSuccess: () => {
			queryClient.invalidateQueries(['venda-list']);
			queryClient.invalidateQueries(['saleWithId', id]);
			history.goBack();
			toast({
				title: 'Atualizado com sucesso!',
				description: 'Venda atualizada com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any) => {
			if (error?.status === 428 || error?.response?.status === 428) {
				if (onErrorHierarchyNotFound) {
					onErrorHierarchyNotFound();
				}
			} else {
				const toastErrors: Array<any> = mapErrorToToastProps(
					error,
					'Erro ao atualizar Venda!'
				);
				toastErrors?.forEach(element => toast(element));
			}
		},
	});
};
